import { render, staticRenderFns } from "./Edit-profile.vue?vue&type=template&id=3547c8d0&scoped=true"
import script from "./Edit-profile.vue?vue&type=script&lang=js"
export * from "./Edit-profile.vue?vue&type=script&lang=js"
import style0 from "./Edit-profile.vue?vue&type=style&index=0&id=3547c8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547c8d0",
  null
  
)

export default component.exports